const values = [
  {name: 'España', value: 'ESP', priority: true},
  {name: 'Francia', value: 'FRA', priority: false},
  {name: 'Marruecos', value: 'MAR', priority: false},
  {name: 'Belgica', value: 'BEL', priority: false},
  {name: 'Afganistan', value: 'AFG', priority: false},
  {name: 'Africa del Sur', value: 'ZAF', priority: false},
  {name: 'Albania', value: 'ALB', priority: false},
  {name: 'Alemania', value: 'DEU', priority: false},
  {name: 'Andorra', value: 'AND', priority: false},
  {name: 'Angola', value: 'AGO', priority: false},
  {name: 'Apátrida', value: 'XXA', priority: false},
  {name: 'Arabia Saudi', value: 'SAU', priority: false},
  {name: 'Argelia', value: 'DZA', priority: true},
  {name: 'Argentina', value: 'ARG', priority: false},
  {name: 'Armenia', value: 'ARM', priority: false},
  {name: 'Australia', value: 'AUS', priority: false},
  {name: 'Austria', value: 'AUT', priority: false},
  {name: 'Azerbaiyan', value: 'AZE', priority: false},
  {name: 'Bahamas', value: 'BHS', priority: false},
  {name: 'Bangladesh', value: 'BGD', priority: false},
  {name: 'Barbados', value: 'BRB', priority: false},
  {name: 'Belice', value: 'BLZ', priority: false},
  {name: 'Benin', value: 'BEN', priority: false},
  {name: 'Bielorrusia', value: 'BLR', priority: false},
  {name: 'Bolivia', value: 'BOL', priority: false},
  {name: 'Bosnia Herzegovina', value: 'BIH', priority: false},
  {name: 'Botswana', value: 'BWA', priority: false},
  {name: 'Brasil', value: 'BRA', priority: false},
  {name: 'Brunei', value: 'BRN', priority: false},
  {name: 'Bulgaria', value: 'BGR', priority: false},
  {name: 'Burkina Faso', value: 'BFA', priority: false},
  {name: 'Burundi', value: 'BDI', priority: false},
  {name: 'Cabo Verde', value: 'CPV', priority: false},
  {name: 'Camboya', value: 'KHM', priority: false},
  {name: 'Camerun', value: 'CMR', priority: false},
  {name: 'Canada', value: 'CAN', priority: false},
  {name: 'Colombia', value: 'COL', priority: false},
  {name: 'Congo', value: 'COG', priority: false},
  {name: 'Congo, Republica Democratica', value: 'COD', priority: false},
  {name: 'Corea del Norte', value: 'PRK', priority: false},
  {name: 'Corea del Sur', value: 'KOR', priority: false},
  {name: 'Costa de Marfil', value: 'CIV', priority: false},
  {name: 'Costa Rica', value: 'CRI', priority: false},
  {name: 'Croacia', value: 'HRV', priority: false},
  {name: 'Cuba', value: 'CUB', priority: false},
  {name: 'Chad', value: 'TCD', priority: false},
  {name: 'Chile', value: 'CHL', priority: false},
  {name: 'China', value: 'CHN', priority: false},
  {name: 'Chipre', value: 'CYP', priority: false},
  {name: 'Dinamarca', value: 'DNK', priority: false},
  {name: 'Djibuti', value: 'DJI', priority: false},
  {name: 'Dominica', value: 'DMA', priority: false},
  {name: 'Ecuador', value: 'ECU', priority: false},
  {name: 'Egipto', value: 'EGY', priority: false},
  {name: 'El Salvador', value: 'SLV', priority: false},
  {name: 'Emiratos Arabes Unidos', value: 'ARE', priority: false},
  {name: 'Eritrea', value: 'ERI', priority: false},
  {name: 'Eslovaquia', value: 'SVK', priority: false},
  {name: 'Eslovenia', value: 'SVN', priority: false},
  {name: 'Estados Unidos', value: 'USA', priority: false},
  {name: 'Estonia', value: 'EST', priority: false},
  {name: 'Etiopia', value: 'ETH', priority: false},
  {name: 'Filipinas', value: 'PHL', priority: false},
  {name: 'Finlandia', value: 'FIN', priority: false},
  {name: 'Gabon', value: 'GAB', priority: false},
  {name: 'Gambia', value: 'GMB', priority: false},
  {name: 'Georgia', value: 'GEO', priority: false},
  {name: 'Ghana', value: 'GHA', priority: false},
  {name: 'Gran Bretana', value: 'GBR', priority: false},
  {name: 'Granada', value: 'GRD', priority: false},
  {name: 'Grecia', value: 'GRC', priority: false},
  {name: 'Guam', value: 'GUM', priority: false},
  {name: 'Guatemala', value: 'GTM', priority: false},
  {name: 'Guinea', value: 'GIN', priority: false},
  {name: 'Guinea Ecuatorial', value: 'GNQ', priority: false},
  {name: 'Guinea-Bissau', value: 'GNB', priority: false},
  {name: 'Guyana', value: 'GUY', priority: false},
  {name: 'Haiti', value: 'HTI', priority: false},
  {name: 'Holanda', value: 'NLD', priority: false},
  {name: 'Honduras', value: 'HND', priority: false},
  {name: 'Hong Kong', value: 'HKG', priority: false},
  {name: 'Hungria', value: 'HUN', priority: false},
  {name: 'India', value: 'IND', priority: false},
  {name: 'Indonesia', value: 'IDN', priority: false},
  {name: 'Iran', value: 'IRN', priority: false},
  {name: 'Iraq', value: 'IRQ', priority: false},
  {name: 'Irlanda', value: 'IRL', priority: false},
  {name: 'Islandia', value: 'ISL', priority: false},
  {name: 'Israel', value: 'ISR', priority: false},
  {name: 'Italia', value: 'ITA', priority: false},
  {name: 'Jamaica', value: 'JAM', priority: false},
  {name: 'Japon', value: 'JPN', priority: false},
  {name: 'Jordania', value: 'JOR', priority: false},
  {name: 'Kazakstab', value: 'KAZ', priority: false},
  {name: 'Kenia', value: 'KEN', priority: false},
  {name: 'Kuwait', value: 'KWT', priority: false},
  {name: 'Laos', value: 'LAO', priority: false},
  {name: 'Lesoto', value: 'LSO', priority: false},
  {name: 'Letonia', value: 'LVA', priority: false},
  {name: 'Libano', value: 'LBN', priority: false},
  {name: 'Liberia', value: 'LBR', priority: false},
  {name: 'Libia', value: 'LBY', priority: false},
  {name: 'Liechtenstein', value: 'LIE', priority: false},
  {name: 'Lituania', value: 'LTU', priority: false},
  {name: 'Luxemburgo', value: 'LUX', priority: false},
  {name: 'Macao', value: 'MAC', priority: false},
  {name: 'Macedonia, Republica', value: 'MKD', priority: false},
  {name: 'Madagascar', value: 'MDG', priority: false},
  {name: 'Malasia', value: 'MYS', priority: false},
  {name: 'Malawi', value: 'MWI', priority: false},
  {name: 'Mali', value: 'MLI', priority: false},
  {name: 'Malta', value: 'MLT', priority: false},
  {name: 'Mauricio', value: 'MUS', priority: false},
  {name: 'Mauritania', value: 'MRT', priority: false},
  {name: 'Mexico', value: 'MEX', priority: false},
  {name: 'Moldavia', value: 'MDA', priority: false},
  {name: 'Monaco', value: 'MCO', priority: false},
  {name: 'Mongolia', value: 'MNG', priority: false},
  {name: 'Mozambique', value: 'MOZ', priority: false},
  {name: 'Myanmar', value: 'MMR', priority: false},
  {name: 'Namibia', value: 'NAM', priority: false},
  {name: 'Nepal', value: 'NPL', priority: false},
  {name: 'Nicaragua', value: 'NIC', priority: false},
  {name: 'Niger', value: 'NER', priority: false},
  {name: 'Nigeria', value: 'NGA', priority: false},
  {name: 'Noruega', value: 'NOR', priority: false},
  {name: 'Nueva Caledonia', value: 'NCL', priority: false},
  {name: 'Nueva Zelanda', value: 'NZL', priority: false},
  {name: 'Oman', value: 'OMN', priority: false},
  {name: 'Pakistan', value: 'PAK', priority: false},
  {name: 'Panama', value: 'PAN', priority: false},
  {name: 'Papua Nueva Guinea', value: 'PNG', priority: false},
  {name: 'Paraguay', value: 'PRY', priority: false},
  {name: 'Peru', value: 'PER', priority: false},
  {name: 'Polonia', value: 'POL', priority: false},
  {name: 'Portugal', value: 'PRT', priority: false},
  {name: 'Puerto Rico', value: 'PRI', priority: false},
  {name: 'Qatar', value: 'QAT', priority: false},
  {name: 'Rep. Checa', value: 'CZE', priority: false},
  {name: 'Republica Centro Africana', value: 'CAF', priority: false},
  {name: 'Republica Dominicana', value: 'DOM', priority: false},
  {name: 'Ruanda', value: 'RWA', priority: false},
  {name: 'Rumania', value: 'ROU', priority: false},
  {name: 'Rusia', value: 'RUS', priority: false},
  {name: 'San Marino', value: 'SMR', priority: false},
  {name: 'Santo Tome y Principe', value: 'STP', priority: false},
  {name: 'Senegal', value: 'SEN', priority: false},
  {name: 'Serbia', value: 'SRB', priority: false},
  {name: 'Seychelles', value: 'SYC', priority: false},
  {name: 'Sierra Leona', value: 'SLE', priority: false},
  {name: 'Singapur', value: 'SGP', priority: false},
  {name: 'Siria', value: 'SYR', priority: false},
  {name: 'Somalia', value: 'SOM', priority: false},
  {name: 'Sri Lanka', value: 'LKA', priority: false},
  {name: 'Sudan', value: 'SDN', priority: false},
  {name: 'Suecia', value: 'SWE', priority: false},
  {name: 'Suiza', value: 'CHE', priority: false},
  {name: 'Surinam', value: 'SUR', priority: false},
  {name: 'Swazilandia', value: 'SWZ', priority: false},
  {name: 'Tailandia', value: 'THA', priority: false},
  {name: 'Taiwan', value: 'TWN', priority: false},
  {name: 'Tanzania', value: 'TZA', priority: false},
  {name: 'Tayikistan', value: 'TJK', priority: false},
  {name: 'Togo', value: 'TGO', priority: false},
  {name: 'Trinidad y Tobago', value: 'TTO', priority: false},
  {name: 'Tunez', value: 'TUN', priority: false},
  {name: 'Turkmenistan', value: 'TKM', priority: false},
  {name: 'Turquia', value: 'TUR', priority: false},
  {name: 'Ucrania', value: 'UKR', priority: false},
  {name: 'Uganda', value: 'UGA', priority: false},
  {name: 'Uruguay', value: 'URY', priority: false},
  {name: 'Vanuatu', value: 'VUT', priority: false},
  {name: 'Vaticano', value: 'VAT', priority: false},
  {name: 'Venezuela', value: 'VEN', priority: false},
  {name: 'Vietnam', value: 'VNM', priority: false},
  {name: 'Yemen', value: 'YEM', priority: false},
  {name: 'Yugoslavia', value: 'YUG', priority: false},
  {name: 'Zambia', value: 'ZMB', priority: false},
  {name: 'Zimbabwe', value: 'ZWE', priority: false}
]

const sort = () =>(
  values.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })
)

const filter = (priority) => (
  sort().filter((value) => {
    return (value.priority === priority)
  })
)

const getValues = () => {
  const d = [{name: 'Divider', value: undefined}]
  const a = filter(true)
  const b = filter(false)

  return [...a, ...d, ...b]
}

export default getValues()



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/countries.js